import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${className}`} data-id="element-175">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-176">
        {children}
      </motion.div>
    </section>;
}